<script>
export default {
  name: 'Equipment',
  data() {
    return {
      equipment: {
        equipment_name: '',
        equipment_type: '',
        equipment_state: '',
        equipment_quality: '',
        equipment_amount: '',
        room_id: 0,
      },
      room_list: [
        {id: 1, name: 'chambre e24'},
        {id: 2, name: 'chambre b21'},
        {id: 3, name: 'chambre a15'},
      ],

    }
  },
  mounted() {
    this.loadRoom()
  },
  methods: {
    loadRoom() {
      this.$axios.get(this.$endpoint.LoadRoom).then(rp => {
        this.room_list = rp.data.filter(room => room.room_status === 400)
      })
    },
    newEquipment() {
      this.$axios.post(this.$endpoint.CreateEquipment, this.equipment)
    },
  },
}
</script>

<template>
<div>
  <v-row>
    <v-col
        cols="12"
        md="12"
    >
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Nouveau &eacute;quipement
            </span>
    </v-col>
  </v-row>
  <v-form
      class="multi-col-validation"
      style="margin-top:1rem;margin-left: 1rem; margin-bottom: 1.5rem;"
  >
    <v-row>
      <v-col
          cols="12"
          md="6"
      >
        <v-text-field
            v-model="equipment.equipment_name"
            dense
            hide-details
            label="Nom"
            outlined
            placeholder="Designation"
        ></v-text-field>
      </v-col>

      <v-col
          cols="12"
          md="6"
      >
        <v-text-field
            v-model="equipment.equipment_amount"
            dense
            hide-details
            type="numeric"
            label="Coût"
            outlined
            placeholder="Prix"
        ></v-text-field>
      </v-col>

      <v-col
          cols="12"
          md="6"
      >
        <v-text-field
            v-model="equipment.equipment_quality"
            dense
            hide-details
            label="Qualité"
            outlined
            placeholder="Marque"
        ></v-text-field>
      </v-col>

      <v-col cols="12"
             md="6">
        <v-text-field
            v-model="equipment.equipment_type"
            dense
            hide-details
            label="Type"
            outlined
            placeholder="exemple: électronique"
        ></v-text-field>
      </v-col>
      <v-col cols="12"
             md="6">
        <v-text-field
            v-model="equipment.equipment_state"
            dense
            hide-details
            label="Etat"
            outlined
            placeholder="exemple: fonctionnel, hors service"
        ></v-text-field>
      </v-col>
      <v-col cols="12"
             md="6">
        <v-select
            v-model="equipment.room_id"
            dense
            name="room_list"
            :item-text="'room_name'"
            :item-value="'id'"
            :items="room_list"
            label="Chambre"
            outlined
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-btn
            color="primary"
            @click="newEquipment"
        >
          Creer
        </v-btn>
        <v-btn
            class="mx-2"
            outlined
            type="reset"
        >
          Annuler
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</div>
</template>

<style scoped>

</style>